import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=2fd37fb8&lang=pug&"
import script from "./exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports